'use strict';

import Vue from 'vue';
import axios from 'axios';
import EventBus from '@/helpers/event-bus.js';
//import Util from '@/mixins/util.js';
import i18n from '../i18n.js';

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  baseURL: process.env.VUE_APP_AXIOSBASE,
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    config.headers['Accept-Language'] = localStorage.getItem('locale')
      ? localStorage.getItem('locale')
      : 'en';
    if (
      config.url.includes('/api/v1/auth/first-login') ||
      !config.url.includes('/api/v1/auth') ||
      config.url.includes('/api/v1/auth-user')
    ) {
      let token = Vue.$keycloak.token;
      // add token to header
      if (token) {
        config.headers.Authorization = 'Bearer ' + token;
      }
    }
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  },
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    if (
      (!response.config.url.includes('/api/v1/auth') ||
        (!response.config.url.includes('/api/v1/landing') &&
          response.config.url.includes('/api/v1/auth-user'))) &&
      response.config.url.includes('/api/v1')
    ) {
      if (Vue.$keycloak.authenticated) {
        Vue.$keycloak
          .updateToken()
          .then(refreshed => {
            if (refreshed) {
              console.debug('Token was successfully refreshed');
            } else {
              console.debug('Token is still valid');
            }
          })
          .catch(err => {
            console.error(err);
          })
          .finally(() => {});
      }
    }
    return response;
  },
  function(error) {
    // Do something with response error
    console.log(error.response.config.url);
    if (error.response.status === 500) {
      EventBus.$emit('snackbar', {
        text: i18n.t('snackbar.error-500'),
        color: 'error',
      });
    } else if (error.response.status === 404) {
      if (!error.response.config.url.includes('campaign/published')) {
        window.location.href = '/page-404';
      }
    } else if (error.response.status === 403) {
      EventBus.$emit('snackbar', {
        text: i18n.t(
          'Please <a href="/#contact-form" target="_blank" style="color: #A870FF; font-weight: bold;">contact us</a> via the contact form for assistance',
        ),
        color: 'warning',
      });
    } else if (error.response.status === 401) {
      if (error.response.config.url.includes('/api/v1/auth')) {
        window.location.href = process.env.VUE_APP_LOGINPATH;
      } else {
        window.location.href = '/page-401';
      }
    } else if (error.response.status === 400) {
      EventBus.$emit('snackbar', {
        text: i18n.t('snackbar.error-400'),
        color: 'warning',
      });
    }
    return Promise.reject(error);
  },
);

/* eslint-disable no-unused-vars */
Plugin.install = function(Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
